/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetFormattedCellSourcesQueryVariables = Types.Exact<{
  cellIds:
    | ReadonlyArray<Types.Scalars["CellId"]["input"]>
    | Types.Scalars["CellId"]["input"];
  cellSources:
    | ReadonlyArray<Types.Scalars["String"]["input"]>
    | Types.Scalars["String"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
}>;

export type GetFormattedCellSourcesQuery = {
  readonly __typename: "Query";
  readonly getFormattedCellSourcesV2: ReadonlyArray<{
    readonly __typename: "FormatCellResult";
    readonly cellId: c.CellId;
    readonly formattedSource: string;
    readonly failed: boolean;
  }>;
};

export const GetFormattedCellSourcesDocument = /*#__PURE__*/ gql`
  query GetFormattedCellSources(
    $cellIds: [CellId!]!
    $cellSources: [String!]!
    $hexVersionId: HexVersionId!
  ) {
    getFormattedCellSourcesV2(
      cellIds: $cellIds
      cellSources: $cellSources
      hexVersionId: $hexVersionId
    ) {
      cellId
      formattedSource
      failed
    }
  }
`;

/**
 * __useGetFormattedCellSourcesQuery__
 *
 * To run a query within a React component, call `useGetFormattedCellSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormattedCellSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormattedCellSourcesQuery({
 *   variables: {
 *      cellIds: // value for 'cellIds'
 *      cellSources: // value for 'cellSources'
 *      hexVersionId: // value for 'hexVersionId'
 *   },
 * });
 */
export function useGetFormattedCellSourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormattedCellSourcesQuery,
    GetFormattedCellSourcesQueryVariables
  > &
    (
      | { variables: GetFormattedCellSourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFormattedCellSourcesQuery,
    GetFormattedCellSourcesQueryVariables
  >(GetFormattedCellSourcesDocument, options);
}
export function useGetFormattedCellSourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormattedCellSourcesQuery,
    GetFormattedCellSourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFormattedCellSourcesQuery,
    GetFormattedCellSourcesQueryVariables
  >(GetFormattedCellSourcesDocument, options);
}
export function useGetFormattedCellSourcesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFormattedCellSourcesQuery,
    GetFormattedCellSourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFormattedCellSourcesQuery,
    GetFormattedCellSourcesQueryVariables
  >(GetFormattedCellSourcesDocument, options);
}
export type GetFormattedCellSourcesQueryHookResult = ReturnType<
  typeof useGetFormattedCellSourcesQuery
>;
export type GetFormattedCellSourcesLazyQueryHookResult = ReturnType<
  typeof useGetFormattedCellSourcesLazyQuery
>;
export type GetFormattedCellSourcesSuspenseQueryHookResult = ReturnType<
  typeof useGetFormattedCellSourcesSuspenseQuery
>;
export type GetFormattedCellSourcesQueryResult = Apollo.QueryResult<
  GetFormattedCellSourcesQuery,
  GetFormattedCellSourcesQueryVariables
>;
